module.exports = "/_next/static/images/ourPartnersAlaska-bcd8c4f33ae4e2fd6cd1ed6e2b31732b.webp";